import { jsx as _jsx } from "tsx-dom/jsx-runtime";
export function ContextMenuOverlay() {
    return (_jsx("div", { id: "context-menu-overlay", class: "hidden", children: _jsx("ul", { id: "context-menu" }) }));
}
